import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { strings, getCurrentLocale } from 'APP_ROOT/localization';
import RavenUtil from 'APP_ROOT/components/common/ravenUtil';
import MyQueryRenderer from "../MyQueryRenderer";
import moment from 'moment';
import ReactTable from 'react-table'; /* for the report tables */
import { csvFormat } from 'd3-dsv';
import 'react-table/react-table.css';

import { requestProfilesForIdentities } from 'APP_ROOT/data/identities/actions';
import ProfileImage from 'APP_ROOT/components/ProfileImage';
import ErrorMessage from 'APP_ROOT/components/ErrorMessage';
import LocationLabel from 'APP_ROOT/components/pages/dashboard/LocationLabel';

import MaintenanceMessage from '../MaintenanceMessage';
import LocationService from '../../../services/locationService';

const LEGACY_FONT_SIZE = 16;
const BASE_FONT_SIZE = 14;
const TEMPLATE_SCALE_FACTOR = BASE_FONT_SIZE / LEGACY_FONT_SIZE;

function toHHMMSS(sec_num) {

    var hours = Math.floor(sec_num / 3600);
    var minutes = sec_num % 3600;
    var seconds = Math.floor(minutes % 60);
    minutes = Math.floor(minutes / 60);

    if (hours < 10) { hours = "0" + hours; }
    if (minutes < 10) { minutes = "0" + minutes; }
    if (seconds < 10) { seconds = "0" + seconds; }

    if (hours === 0)
        return minutes + ':' + seconds;
    else
        return hours + ':' + minutes + ':' + seconds;
}


function formatEndTime(startTime, endTime) {
    var endFormated = endTime.format("hh:mm:ss a");
    if (startTime.format("MMM Do YYYY") == endTime.format("MMM Do YYYY")) {
        return endFormated;
    }

    var days = endTime.diff(startTime, 'days') + 1;

    var daysText;

    daysText = "+" + days + " " + (days === 1 ? strings.day : strings.days);

    return [
        endFormated,
        <br />,
        daysText
    ];
}


function parsePosition(wkt) {

    if (!wkt) return null;

    var regexstring = 'POINT\\((-?\\d+\\.\\d+) (-?\\d+\\.\\d+)\\)';

    // var re = new RegExp('POINT\((-?\d+\.\d+) (-?\d+\.\d+)\)', 'ig');
    var re = new RegExp(regexstring, 'ig');

    var pos = re.exec(wkt);

    if (pos && pos.length > 2) {
        return {
            'lat': pos[1],
            'lon': pos[2],
        };
    }
    return null;

}


function getRawData(resultSet) {
    var rows = [];

    if ('rawData' in resultSet) {
        rows = resultSet.rawData();
    }
    else {
        for (var i = 0; ; i++) {
            if (resultSet.hasOwnProperty(i.toString())) {
                rows = rows.concat(resultSet[i.toString()].rawData());
                continue;
            }
            else {
                break;
            }
        }
    }

    return rows;
}


function getDaysBetweenDates(start, end) {

    var now = start.clone(), dates = [];

    while (now.isSameOrBefore(end)) {
        dates.push(now.format('YYYY-MM-DD'));
        now.add(1, 'days');
    }

    return dates;

}


class ReportsSection extends React.PureComponent {

    cardTypeFilterValues = () => {
        switch (this.props.showDrivingParking) {
            case 'trip':
                return ['trip'];
            case 'parked':
                return ['parked'];
            case 'both':
            default:
                return null;
        }
    }

    cardTypeFilter = () => {
        const filterValues = this.cardTypeFilterValues();
        return filterValues ? {
            "dimension": "DimCard.type",
            "operator": "equals",
            "values": filterValues
        } : null;
    }

    render() {

        const filters = [
            this.cardTypeFilter()
        ].filter(it => it); // drop null filters

        var basicQuery = null;

        if (this.props.features.facial_recognition) {
            basicQuery = {
                "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
                "measures": [
                    "FactSegment.distance",
                    "FactSegment.durationInSeconds",
                    "FactSegment.avgSpeed",
                    "FactSegment.maxSpeed",
                    "FactSegment.odometerInKilometers",
                    "FactGeofenceState.durationInSeconds",
                ],
                "timeDimensions": [
                    {
                        "dimension": "FactSegment.startTime",
                        "dateRange": [
                            moment(this.props.selectedDateRange[0]).format('YYYY-MM-DD'),
                            moment(this.props.selectedDateRange[1]).format('YYYY-MM-DD'),
                        ]
                    }
                ],
                "dimensions": [
                    "DimDriver.name",
                    "DimDriver.identityId",
                    "DimVehicle.name",
                    "DimVehicle.vin", // ADDED
                    "FactSegment.segId",
                    "FactSegment.type",
                    "FactSegment.startTime",
                    "FactSegment.endTime",
                    "FactSegment.startPosition",
                    "FactSegment.endPosition",
                    "DimCard.cardId",
                    "DimCard.type",
                    "DimCard.startLocationName",
                    "DimCard.endLocationName",
                    "DimRaven.uuid",
                    "DimGeofence.name",
                    "DimGeofence.description",
                ],
                filters
            };
        }
        else {
            basicQuery = {
                "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
                "measures": [
                    "FactSegment.distance",
                    "FactSegment.durationInSeconds",
                    "FactSegment.avgSpeed",
                    "FactSegment.maxSpeed",
                    "FactSegment.odometerInKilometers",
                    "FactGeofenceState.durationInSeconds",
                ],
                "timeDimensions": [
                    {
                        "dimension": "FactSegment.startTime",
                        "dateRange": [
                            moment(this.props.selectedDateRange[0]).format('YYYY-MM-DD'),
                            moment(this.props.selectedDateRange[1]).format('YYYY-MM-DD'),
                        ]
                    }
                ],
                "dimensions": [
                    "DimVehicle.name",
                    "DimVehicle.vin", // ADDED
                    "FactSegment.segId",
                    "FactSegment.type",
                    "FactSegment.startTime",
                    "FactSegment.endTime",
                    "FactSegment.startPosition",
                    "FactSegment.endPosition",
                    "DimCard.cardId",
                    "DimCard.type",
                    "DimCard.startLocationName",
                    "DimCard.endLocationName",
                    "DimRaven.uuid",
                    "DimGeofence.name",
                    "DimGeofence.description",
                ],
                filters
            };
        }

        var queries = [];

        var days = getDaysBetweenDates(moment(this.props.selectedDateRange[0]),
            moment(this.props.selectedDateRange[1]));

        basicQuery.limit = 9000;

        for (var i = 0; i < days.length; i++) {

            let minday = "" + days[i] + "T00:00:00";
            let maxday = "" + days[i] + "T23:59:59";
            if (i < (days.length - 1)) {
                maxday = "" + days[i + 1] + "T00:00:00";
            }

            basicQuery.timeDimensions = [
                {
                    "dimension": "FactSegment.startTime",
                    "dateRange": [minday, maxday]
                }
            ];


            queries.push({ ...basicQuery });

        }

        return (
            <MyQueryRenderer
                user={this.props.user}
                cubejsApi={this.props.cubejsApi}
                queries={queries}
                render={this.renderChart(basicQuery, ConnectedReportTable, this.props)}
            />
        );

    }

    renderChart = (myLastQuery, Component, props) => ({ resultSet, error, loadingState, ...otherProps }) => {
        if (error) {
            return this.renderError(error);
        } else if (resultSet) {
            return (
                <Component
                    {...otherProps}
                    stage={props.user.stage}
                    groupBy={props.groupBy}
                    unitOfMeasure={props.unitOfMeasure}
                    features={props.features}
                    resultSet={resultSet}
                    loadingState={loadingState}
                    limitTo={props.limitTo}
                    limitToFilteredResources={props.limitToFilteredResources}
                />
            );
        } else {
            return <div>{strings.loading}</div>;
        }
    };

    renderError = error => {
        if (error.message && error.message.match(/maintenance/i)) {
            return <MaintenanceMessage message={error.message} />;
        } else {
            return <ErrorMessage error={error} />;
        }
    }
}

class ReportTable extends React.PureComponent {
    state = {
        exportURI: null
    };


    componentDidMount() {
        this.fetchIdentities();
    }

    componentDidUpdate() {
        this.fetchIdentities();
    }

    fetchIdentities = () => {
        if (this.props.features.facial_recognition) {
            const identityIds = new Set();
            const rows = getRawData(this.props.resultSet);
            rows.forEach(r => {
                if (r['DimDriver.identityId']) identityIds.add(r['DimDriver.identityId']);
            });
            this.props.dispatch(requestProfilesForIdentities(this.props.stage, Array.from(identityIds)));
        }
    }

    getDimensionColumn = (name, field, overrides = {}) => {
        return ({
            Header: name,
            accessor: d => d[field],
            id: field,
            maxWidth: 220 * TEMPLATE_SCALE_FACTOR,
            filterMethod: (filter, row) => {
                var found = false;

                var needle = filter.value.toLowerCase();

                if (row[filter.id]) {
                    if (row[filter.id].toLowerCase().contains(needle)) return true;
                }
                if (row._subRows) {
                    row._subRows.forEach(r => {
                        if (r[filter.id] && r[filter.id].toLowerCase().contains(needle)) found = true;
                    });
                }
                return found;
            },

            ...overrides
        });
    };

    getIdentityId = row => {
        if (row['DimDriver.identityId']) {
            return row['DimDriver.identityId'];
        }
        if (row._subRows && row._subRows[0]) {
            return this.getIdentityId(row._subRows[0]);
        }
        return null;
    }

    generateExportURI = (columns, rawRows) => {
        const outputRows = rawRows.map(row => {
            const outRow = {};
            columns.forEach(col => {
                if ((col.show || col.show === undefined || col.export)
                    && (col.export || col.export === undefined)) {
                    if (col.exportAccessor) {
                        outRow[col.Header] = (typeof col.exportAccessor === 'string' ? row[col.exportAccessor] : col.exportAccessor(row));
                    } else {
                        outRow[col.Header] = (typeof col.accessor === 'string' ? row[col.accessor] : col.accessor(row));
                    }
                }
            });
            return outRow;
        });
        const BOM = '\uFEFF';
        return `data:text/csv;charset=utf-8,${BOM}${encodeURIComponent(csvFormat(outputRows))}`;
    }

    /* bundle aggregate values in a single value (string) such that they can be separated during render (in "Aggregated")*/
    generateAggregatedToPreserveIndividualValues(valuesArray) {
        return JSON.stringify(valuesArray); // TODO values are actually single items, what am I missing here?
    }

    /* separates the values bundled in a single string (in generateAggregatedToPreserveIndividualValues) and return the array of parsed values to be rendered */
    getValuesArrayFromAggregated(aggregatedRowValue) {
        if (aggregatedRowValue === null || aggregatedRowValue === undefined) return [];
        if (Array.isArray(aggregatedRowValue)) return aggregatedRowValue.filter(v => v !== null && v !== undefined);
        try {
            const parsed = JSON.parse(aggregatedRowValue);
            if (Array.isArray(parsed)) {
                return parsed.filter(v => v !== null && v !== undefined);
            }
            return [parsed];
        } catch (e) {
            return [aggregatedRowValue];
        }
    }

    async enrichRowsWithAddresses(rows) {
        return Promise.all(rows.map(async (row) => {
            const start = row['FactSegment.startPosition'];
            const end = row['FactSegment.endPosition'];

            if (start?.lat && start?.lon) {
                row.startAddress = await LocationService.reverseGeocode(start.lat, start.lon);
            }

            if (end?.lat && end?.lon) {
                row.endAddress = await LocationService.reverseGeocode(end.lat, end.lon);
            }

            return row;
        }));
    }

    generateCSV = async (columns, rows) => {
        const enrichedRows = await this.enrichRowsWithAddresses(rows);
        const uri = this.generateExportURI(columns, enrichedRows);
        this.setState({ exportURI: uri });
    };

    render() {
        const { resultSet, stage } = this.props;

        this.units = 0;
        this.unitsString = '(mi)';

        if (this.props.unitOfMeasure === 'METRIC') {
            // Units string defaults to miles
            this.units = 1;
            this.unitsString = '(km)';
        }

        var pivots = [];
        var dims = [];
        var sort = [];
        var removeParked = false;

        if (this.props.groupBy === "vehicle") {
            pivots.push('DimVehicle.name');
            dims.push(this.getDimensionColumn(strings.reports_header_vehicle, 'DimVehicle.name'));
            sort.push({ id: 'DimVehicle.name', desc: false });
        }
        else if (this.props.groupBy === "driver") {
            removeParked = true;

            pivots.push('DimDriver.name');
            dims.push(this.getDimensionColumn(strings.reports_header_driver, 'DimDriver.name', {
                Pivot: cellInfo => {
                    const identityId = this.getIdentityId(cellInfo.row);
                    const name = cellInfo.value;
                    const classes = cellInfo.isExpanded === undefined || cellInfo.isExpanded === false ? "rt-expander" : "rt-expander -open";
                    // TODO: no need to replace name conditionally with strings.unknown here if we group by identityId
                    return (
                        <ProfileImage
                            identityId={identityId}
                            caption={name.startsWith(strings.unknown) ? strings.unknown : name}
                            stage={stage}
                            imgSize='96px'
                            expander={true}
                            expanderClass={classes}
                        />
                    );
                },
            }));
            sort.push({ id: 'DimDriver.name', desc: false });
        }
        else if (this.props.groupBy === "vehicle,driver") {
            removeParked = true;
            pivots.push('DimVehicle.name');
            pivots.push('DimDriver.name');
            dims.push(this.getDimensionColumn(strings.reports_header_vehicle, 'DimVehicle.name'));
            dims.push(this.getDimensionColumn(strings.reports_header_driver, 'DimDriver.name', {
                className: 'aggregate-list',
                Pivot: cellInfo => {
                    const identityId = this.getIdentityId(cellInfo.row);
                    const name = cellInfo.value;
                    const classes = cellInfo.isExpanded === undefined || cellInfo.isExpanded === false ? "rt-expander" : "rt-expander -open";
                    return (
                        <ProfileImage
                            identityId={identityId}
                            caption={name.startsWith(strings.unknown) ? strings.unknown : name}
                            stage={stage}
                            imgSize='64px'
                            expander={true}
                            expanderClass={classes}
                        />
                    );
                },
                aggregate: vals => {
                    /* TODO: using custom aggregate to sanitize strings.unknowns, but it would be nice if this could be avoided */
                    if (vals.length <= 0) {
                        return null;
                    }
                    var myset = new Set();

                    vals.forEach(x => {

                        if (x.startsWith(strings.unknown)) // TODO: This will prevent users from having custom names starting with strings.unknown (e.g. "Unknown Soldier" (shrug, best I could think of)
                        {
                            myset.add(strings.unknown);
                        }
                        else {
                            myset.add(x);
                        }
                    });

                    var result = [];

                    myset.forEach((it) => {
                        result.push(it);
                    });
                    return this.generateAggregatedToPreserveIndividualValues(result);
                },
                Aggregated: row => {

                    const values = this.getValuesArrayFromAggregated(row.value);

                    return (  /* mimicking default ReactTable <span> rendering (for example, groupBy "driver,vehicle" below renders using <span> since we don't custom aggregate */
                        <span>
                            {values.map((value, index) => {
                                return <span key={index}>
                                    {value}
                                    {index === values.length - 1 ? "" : ","}
                                </span>
                            })}
                        </span>
                    )
                }
            }));
            sort.push({ id: 'DimVehicle.name', desc: false });
            sort.push({ id: 'DimDriver.name', desc: false });
        }
        else if (this.props.groupBy === "driver,vehicle") {
            removeParked = true;
            pivots.push('DimDriver.name');
            pivots.push('DimVehicle.name');
            dims.push(this.getDimensionColumn(strings.reports_header_driver, 'DimDriver.name', {
                className: 'aggregate-list',
                Pivot: cellInfo => {
                    const identityId = this.getIdentityId(cellInfo.row);
                    const name = cellInfo.value;
                    const classes = cellInfo.isExpanded === undefined || cellInfo.isExpanded === false ? "rt-expander" : "rt-expander -open";
                    return (
                        <ProfileImage
                            identityId={identityId}
                            caption={name.startsWith(strings.unknown) ? strings.unknown : name}
                            stage={stage}
                            expander={true}
                            expanderClass={classes}
                            imgSize='96px'
                        />
                    );
                },
            }));
            dims.push(this.getDimensionColumn(strings.reports_header_vehicle, 'DimVehicle.name'));
            sort.push({ id: 'DimDriver.name', desc: false });
            sort.push({ id: 'DimVehicle.name', desc: false });
        }
        else {
            pivots.push('DimVehicle.name');
            dims.push(this.getDimensionColumn(strings.reports_header_vehicle, 'DimVehicle.name'));
            sort.push({ id: 'DimVehicle.name', desc: false });
        }

        // VIN column with aggregation (collapse repeated VINs in grouped/pivoted rows)
        dims.push(this.getDimensionColumn(strings.reports_header_vin, 'DimVehicle.vin', {
            aggregate: vals => {
                if (!vals || vals.length === 0) return null;
                const set = new Set();
                vals.forEach(v => { if (v) set.add(v); });
                return this.generateAggregatedToPreserveIndividualValues(Array.from(set));
            },
            Aggregated: row => {
                if (!row || !row.value) return null;
                const values = this.getValuesArrayFromAggregated(row.value);
                if (!values) return null;
                return (
                    <span>
                        {values.map((value, index) => (
                            <span key={index}>{value}{index === values.length - 1 ? '' : ','}</span>
                        ))}
                    </span>
                );
            },
        }));

        const columns = dims.concat([
            {
                accessor: d => d['DimDriver.identityId'],
                id: 'DimDriver.identityId',
                show: false,
                filterable: false,
            },
            {
                Header: strings.reports_header_date,
                className: 'aggregate-list',
                accessor: d => d['FactSegment.startTime'],
                id: 'FactSegment.startTime',
                filterable: false,
                maxWidth: 120 * TEMPLATE_SCALE_FACTOR,
                Cell: x => <div> {x.value ? moment.utc(x.value).local().format("MMM Do YYYY") : "-"} </div>,
                PivotValue: x => <div> {x.value ? moment.utc(x.value).format("MMM Do YYYY") : "-"} ({x.subRows.length})</div>,
                aggregate: vals => {
                    if (vals.length <= 0) {
                        return null;
                    }
                    var min = vals[0];
                    var max = vals[0];
                    vals.forEach(x => {
                        if (Array.isArray(x)) {
                            if (min > x[0]) min = x[0];
                            if (max < x[1]) max = x[1];
                        }
                        else {
                            if (min > x) min = x;
                            if (max < x) max = x;
                        }

                    });
                    if (min === max)
                        return min;
                    return [min, max];
                },
                Aggregated: (x) => {
                    /* mimicking default ReactTable <span> rendering (for example, groupBy "driver,vehicle" above renders using <span> since we don't custom aggregate */
                    return x.value && x.value.length === 2 ? (
                        <span>
                            <span>{moment.utc(x.value[0]).local().format("MMM Do YYYY")} - </span>
                            <span>{moment.utc(x.value[1]).local().format("MMM Do YYYY")}</span>
                        </span>
                    ) : (
                        <span>
                            -
                        </span>
                    );
                }
            },
            {
                Header: strings.reports_header_type,
                Cell: d => {
                    if (d.value === "trip")
                        return (<img src="/images/icon-driving_default-offset_h144-black.svg" className="icon-trip-type driving"></img>); /* was /images/icon-driving_h144.png */
                    if (d.value === "single")
                        return (<img src="/images/icon-driving_one-driver_h144-black.svg" className="icon-trip-type driving"></img>); /* was /images/ic_person_48px.svg */
                    if (d.value === "multi")
                        return (<img src="/images/icon-driving_multiple-drivers_h144-black.svg" className="icon-trip-type driving"></img>); /* was /images/multiple-occupants-icon-base64encode-black-source.svg */
                    else
                        return (<img src="/images/icon-parked_h144.png" className="icon-trip-type parked"></img>);
                },
                accessor: d => d['DimCard.type'],
                exportAccessor: d => d['DimCard.type'] === "trip" || d['DimCard.type'] === "single" || d['DimCard.type'] === "multi" ? "trip" : "parked",
                id: 'DimCard.type',
                filterable: false,
                maxWidth: 50 * TEMPLATE_SCALE_FACTOR,
                aggregate: vals => { return vals.reduce((total, curVal) => { if (total === "multi") return total; if (total === "trip") return total; return curVal; }) },
                Aggregated: d => {
                    if (d.value === "trip")
                        return (<img src="/images/icon-driving_default-offset_h144-black.svg" className="icon-trip-type driving"></img>); /* was /images/icon-driving_h144.png */
                    if (d.value === "single")
                        return (<img src="/images/icon-driving_one-driver_h144-black.svg" className="icon-trip-type driving"></img>); /* was /images/ic_person_48px.svg */
                    if (d.value === "multi")
                        return (<img src="/images/icon-driving_multiple-drivers_h144-black.svg" className="icon-trip-type driving"></img>); /* was /images/multiple-occupants-icon-base64encode-black-source.svg */
                    else
                        return (<img src="/images/icon-parked_h144.png" className="icon-trip-type parked"></img>);
                },
            },
            {
                Header: strings.reports_header_start_time,
                Cell: x => <div title={moment.utc(x.value).local().format("LLLL")} >{moment.utc(x.value).local().format("hh:mm:ss a")}</div>,
                accessor: d => d['FactSegment.startTime'],
                maxWidth: 100 * TEMPLATE_SCALE_FACTOR,
                aggregate: vals => vals.reduce((total, curVal) => { return moment(total) > moment(curVal) ? total : curVal }),
                id: 'starttime',
                Aggregated: d => null,
                filterable: false,
                // Start/End
            },
            {
                Header: strings.reports_header_end_time,
                Cell: x => <div title={moment.utc(x.value).local().format("LLLL")}> {formatEndTime(moment.utc(x.original['FactSegment.startTime']).local(), moment.utc(x.value).local())} </div>,
                accessor: d => d['FactSegment.endTime'],
                maxWidth: 100 * TEMPLATE_SCALE_FACTOR,
                aggregate: vals => vals.reduce((total, curVal) => { return moment(total) < moment(curVal) ? total : curVal }),
                id: 'endtime',
                Aggregated: d => null,
                filterable: false,
                // Start/End
            },
            {
                Header: strings.reports_header_driving_duration,
                Cell: d => (<div>{toHHMMSS(d.value)}</div>),
                accessor: d => d['FactSegment.drivingSeconds'],
                id: 'FactSegment.drivingSeconds',
                maxWidth: 80 * TEMPLATE_SCALE_FACTOR,
                aggregate: vals => vals.reduce((it, acc) => acc + it, 0),
                Aggregated: d => (<div>{toHHMMSS(d.value)}</div>),
                filterable: false,
            },
            {
                Header: strings.reports_header_parked_duration,
                Cell: d => (<div>{toHHMMSS(d.value)}</div>),
                accessor: d => d['FactSegment.parkedSeconds'],
                id: 'FactSegment.parkedSeconds',
                maxWidth: 80 * TEMPLATE_SCALE_FACTOR,
                aggregate: vals => vals.reduce((it, acc) => acc + it, 0),
                Aggregated: d => (<div>{toHHMMSS(d.value)}</div>),
                filterable: false,
            },
            {
                Header: strings.reports_header_start_location,
                Cell: (d) => { if (d.original['FactSegment.startPosition'] && d.original['FactSegment.startPosition'].lat) return <LocationLabel withStreetNumber={true} addMapLink={true} location={d.original['FactSegment.startPosition']} />; if (d.value) return <div>{d.value}</div>; return null; },
                accessor: d => d['DimCard.startLocationName'],
                exportAccessor: d => d.startAddress || '',
                id: 'DimCard.startLocationName',
                aggregate: vals => { return vals.find((curVal) => { return curVal }) },
                Aggregated: d => null,
                filterable: false,
                // Start/End
            },
            {
                Header: strings.reports_header_end_location,
                Cell: (d) => { if (d.original['FactSegment.endPosition'] && d.original['FactSegment.endPosition'].lat) return <LocationLabel withStreetNumber={true} addMapLink={true} location={d.original['FactSegment.endPosition']} />; if (d.value) return <div>{d.value}</div>; return null; },
                accessor: d => d['DimCard.endLocationName'],
                exportAccessor: d => d.endAddress || '',
                id: 'DimCard.endLocationName',
                aggregate: vals => { return vals.find((curVal) => { return curVal }) },
                Aggregated: d => null,
                filterable: false,
                // Start/End
            },
            {
                Header: strings.reports_header_distance_short_form + ' ' + this.unitsString,
                accessor: d => RavenUtil.round(RavenUtil.convertDistance(d['FactSegment.distance'], this.units), 1),
                Cell: d => d.value.toFixed(1),
                id: 'FactSegment.distance',
                maxWidth: 80 * TEMPLATE_SCALE_FACTOR,
                aggregate: vals => vals.reduce((total, curVal) => total + (curVal ? curVal : 0), 0),
                className: 'number',
                headerClassName: 'number-header',
                filterable: false,
            },
            {
                Header: strings.reports_header_odometer + ' ' + this.unitsString,
                accessor: d => d ? RavenUtil.round(RavenUtil.convertDistance(d['FactSegment.odometerInKilometers'], this.units), 0) : 0,
                Cell: d => d && d.value > 0 ? d.value.toFixed(0) : '-',
                id: 'FactSegment.odometerInKilometers',
                maxWidth: 98 * TEMPLATE_SCALE_FACTOR,
                aggregate: vals => vals.reduce((total, curVal) => curVal > total ? curVal : total, 0),
                Aggregated: row => {

                    return (
                        <span>
                            {row.value ? row.value : '-'}
                        </span>
                    )
                },
                className: 'number',
                headerClassName: 'number-header',
                filterable: false,
            },
            {
                Header: strings.reports_header_geofences,
                className: 'aggregate-list',
                Cell: ({ value }) => (<span>{value && Array.from(value).map((name, i) => <span key={i}>{name},</span>)}</span>),
                accessor: d => d.geofences,
                aggregate: vals => {
                    if (vals.length <= 0) {
                        return [];
                    }
                    var myset = new Set();

                    vals.forEach(x => {
                        x.forEach(y => {
                            myset.add(y);
                        });
                    });

                    return Array.from(myset);

                },
                Aggregated: row => {

                    return (  /* mimicking default ReactTable <span> rendering (for example, groupBy "driver,vehicle" below renders using <span> since we don't custom aggregate */
                        <span>
                            {row.value.map((value, index) => {
                                return <span key={index}>
                                    {value}
                                    {index === row.value.length - 1 ? "" : ","}
                                </span>
                            })}
                        </span>
                    )
                },
                id: 'DimGeofence.name',
                filterMethod: (filter, row) => {
                    var found = false;

                    var needle = filter.value.toLowerCase();

                    row[filter.id].forEach(x => {

                        var haystack = x.toLowerCase();
                        if (haystack.contains(needle)) found = true;
                    });

                    return found;
                },
                export: false
            },
            {
                Header: strings.reports_header_details,
                id: 'url',
                accessor: d => {
                    return d['DimCard.cardId'] && d['DimRaven.uuid'] ? d['DimRaven.uuid'] + "/" + d['DimCard.cardId'] : null;
                },
                maxWidth: 100 * TEMPLATE_SCALE_FACTOR,
                aggregate: vals => null,
                Cell: d => d.value ? <a href={d.original._historyUrlOverride || `/${getCurrentLocale()}/stats/history/${d.value}`} target="_blank" rel="noopener noreferrer">{strings.action_details}</a> : null,
                export: false,
                filterable: false,
            },
        ]);

        // limit to ravens that are included in the selected tags
        const rows = this.props.limitToFilteredResources(getRawData(resultSet), this.props.limitTo);

        // Roll up the rows (segments) into cards
        // obj holds all cards in a 'data' variable, keyed on card id
        const cards = rows.reduce((obj, row) => {
            var cardid = `${row['DimRaven.uuid']}.${row['DimCard.cardId']}`;
            var curcard = {
                'FactSegment.parkedSeconds': 0,
                'FactSegment.drivingSeconds': 0,
            };

            if (row['DimVehicle.name'] === null) {
                console.error('DimVehicle.name is null. This is NOT supposed to happen.');
                row['DimVehicle.name'] = strings.unknown;
            }

            if (obj.data[cardid]) {
                curcard = obj.data[cardid];

                // Add geofences
                if (row['DimGeofence.name']) {
                    curcard.geofences.add(row['DimGeofence.name']);
                }

                if (!curcard.segments.has(row['FactSegment.segId'])) {
                    curcard['FactSegment.distance'] += row['FactSegment.distance'];
                    curcard['FactSegment.durationInSeconds'] += row['FactSegment.durationInSeconds'];
                    if (row['FactSegment.type'] === 'parked') {
                        curcard['FactSegment.parkedSeconds'] += row['FactSegment.durationInSeconds'];
                    }
                    else {
                        curcard['FactSegment.drivingSeconds'] += row['FactSegment.durationInSeconds'];
                    }

                    if (curcard['FactSegment.maxSpeed'] < row['FactSegment.maxSpeed']) {
                        curcard['FactSegment.maxSpeed'] = row['FactSegment.maxSpeed'];
                    }
                    if (curcard['FactSegment.odometerInKilometers'] < row['FactSegment.odometerInKilometers']) {
                        curcard['FactSegment.odometerInKilometers'] = row['FactSegment.odometerInKilometers'];
                    }
                    // FIXME -  FactSegment.avgSpeed:

                    // already multi driver?
                    if (!curcard['DimDriver.identityId']) {
                        // If nothing is recognized on this segment, but a previous segment had an identity, use that
                        curcard['DimDriver.identityId'] = row['DimDriver.identityId'];
                        if (!curcard['DimDriver.name']) {
                            // If we don't have an identity or name, copy both.
                            curcard['DimDriver.name'] = row['DimDriver.name'];
                        }
                        curcard['DimCard.type'] = "single";
                    }
                    else if (row['DimDriver.identityId'] && curcard['DimDriver.identityId'] !== row['DimDriver.identityId']) {
                        // looks like multidriver, make it so
                        // console.log("Card", cardid, "different drivers", curcard['DimDriver.identityId'], row['DimDriver.identityId'], curcard['DimDriver.name'], row['DimDriver.name']);
                        curcard.multidriver = 1;
                        curcard['DimCard.type'] = "multi";
                    }

                    if (moment(curcard['FactSegment.startTime']) > moment(row['FactSegment.startTime'])) {
                        curcard['FactSegment.startTime'] = row['FactSegment.startTime'];
                    }
                    if (moment(curcard['FactSegment.endTime']) < moment(row['FactSegment.endTime'])) {
                        curcard['FactSegment.endTime'] = row['FactSegment.endTime'];
                    }

                    curcard.startPositions[row['FactSegment.segId']] = row['FactSegment.startPosition'];
                    curcard.endPositions[row['FactSegment.segId']] = row['FactSegment.endPosition'];

                    curcard.segments.add(row['FactSegment.segId']);

                    curcard['segmentcount'] += 1;
                }
            }
            else {
                // Only remove parked segments if they are the first segment in the card
                if (removeParked) {
                    // Skip any cards that aren't 'trip' when removing parked
                    if (row['DimCard.type'] !== 'trip') return obj;
                }

                curcard = { ...row };

                curcard.segments = new Set();
                curcard.segments.add(row['FactSegment.segId']);

                curcard.geofences = new Set();

                curcard['FactSegment.parkedSeconds'] = 0;
                curcard['FactSegment.drivingSeconds'] = 0;

                if (row['FactSegment.type'] === 'parked') {
                    curcard['FactSegment.parkedSeconds'] = row['FactSegment.durationInSeconds'];
                }
                else {
                    curcard['FactSegment.drivingSeconds'] = row['FactSegment.durationInSeconds'];
                }

                curcard.startPositions = new Array();
                curcard.startPositions[row['FactSegment.segId']] = row['FactSegment.startPosition'];
                curcard.endPositions = new Array();
                curcard.endPositions[row['FactSegment.segId']] = row['FactSegment.endPosition'];

                curcard['segmentcount'] = 1;

                if (row['DimGeofence.name']) {
                    curcard.geofences.add(row['DimGeofence.name']);
                }
            }

            // apply rollup to our reduce object
            obj.data[cardid] = curcard;

            // reverse lookup set
            obj.indexes.add(cardid);

            if (row["DimDriver.identityId"]) obj.identityIds.add(row["DimDriver.identityId"]);

            return obj;

        }, { data: {}, indexes: new Set(), identityIds: new Set() });

        const finalcards = [];
        cards.indexes.forEach((it) => {
            var curcard = cards.data[it];

            // TODO: group by identityId only, not name. let name just be strings.unknown
            if (!curcard['DimDriver.name'] && curcard['DimDriver.identityId']) {
                curcard['DimDriver.name'] = strings.unknown + curcard['DimDriver.identityId'];
            }
            if (!curcard['DimDriver.name']) {
                curcard['DimDriver.name'] = strings.unknown;
            }

            curcard['DimGeofence.name'] = Array.from(curcard.geofences).join();

            // Translate start and end position from text to array

            var minSeg = Math.min(...curcard.segments);
            var maxSeg = Math.max(...curcard.segments);

            curcard['FactSegment.startPosition'] = parsePosition(curcard.startPositions[minSeg]);
            curcard['FactSegment.endPosition'] = parsePosition(curcard.endPositions[maxSeg]);

            finalcards.push(curcard);
        });

        if (!finalcards || finalcards.length <= 0) {
            return (
                <div>
                    <h4>{strings.reports_no_data_for_selected_time_period}</h4>
                </div>
            );
        }

        if (!this.state.exportURI && finalcards.length > 0) {
            this.generateCSV(columns, finalcards);
        }

        if (this.props.historyUrlOverride) {
            finalcards.forEach(c => c._historyUrlOverride = this.props.historyUrlOverride);
        }

        return (
            <div>
                <ReactTable
                    filterable={true}
                    data={finalcards}
                    columns={columns}
                    noDataText={strings.reports_no_data_for_selected_time_period}
                    showPagination={false}
                    defaultPageSize={Number.MAX_SAFE_INTEGER} // RAV-1942, step one (effectively "set the page size to the number of rows" returned from the database)
                    minRows={0} /* 0, do not show empty filler rows */
                    pivotBy={pivots}
                    defaultSorted={[
                        ...sort,
                        {
                            id: 'FactSegment.startTime',
                            desc: false
                        }
                    ]}
                    getTrProps={(state, rowInfo, column) => {
                        if (rowInfo && rowInfo.aggregated)
                            return { className: '-rollup' };
                        return { className: '-padRow' };
                    }}
                />
                <div className='text-right mt-1'>
                    <a
                        className='btn btn-outline-blue btn-sm'
                        download="trip-report.csv"
                        id="export-link"
                        href={this.state.exportURI || '#'}
                        onClick={(e) => {
                            if (!this.state.exportURI) e.preventDefault();
                        }}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {this.state.exportURI ? strings.action_export_CSV : strings.generate_CSV}
                    </a>
                </div>
            </div>
        );
    }
}

const ConnectedReportTable = connect()(ReportTable);

ReportsSection.propTypes = {
    selectedDateRange: PropTypes.instanceOf(Array).isRequired,
    showDrivingParking: PropTypes.oneOf(['trip', 'parked', 'both']).isRequired,
    unitOfMeasure: PropTypes.string.isRequired,
}

export default ReportsSection;
